// ColonCard.jsx

import React from "react";
import BasePackageCard from "./BasePackageCard";
import { COLON } from "../../../../constants";
import { useTranslation } from "../../../../language";

export default function ColonCard() {
  const { t } = useTranslation();

  const panel = {
    id: "colon",
    title: t("card_colon_title"),
    subtitle: t("card_colon_desc"),
    biomarkers: t("card_colon_markers"),
    price: "€ 19",
    image: COLON,
  };

  return <BasePackageCard panel={panel} />;
}